export default "__VITE_ASSET__097bebdc__"